const isTrue = (value: unknown): boolean =>
  String(value ?? "").trim().toLowerCase() === "true";

// When this env var is true (set it only on staging), the Cmd+Shift+D
// keyboard shortcut can toggle all dev flags on at runtime.
export const DEV_SHORTCUT_ALLOWED =
  isTrue(import.meta.env.VITE_ALLOW_DEV_SHORTCUT);

const STORAGE_KEY = 'baba_dev_mode';

// Returns true if the runtime dev-mode toggle is active (set via keyboard shortcut).
export const isRuntimeDevMode = (): boolean =>
  localStorage.getItem(STORAGE_KEY) === 'true';

// Toggles runtime dev mode and reloads so all flag constants re-evaluate.
export const toggleRuntimeDevMode = (): void => {
  const next = !isRuntimeDevMode();
  if (next) {
    localStorage.setItem(STORAGE_KEY, 'true');
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
  window.location.reload();
};

const flag = (envValue: unknown): boolean =>
  isTrue(envValue) || (DEV_SHORTCUT_ALLOWED && isRuntimeDevMode());

export const DEV_BYPASS_IDENTITY_VERIFICATION =
  flag(import.meta.env.VITE_DEV_BYPASS_IDENTITY_VERIFICATION);

export const DEV_BYPASS_RESUME_SCREENING =
  flag(import.meta.env.VITE_DEV_BYPASS_RESUME_SCREENING);

export const DEV_BYPASS_BEHAVIORAL_INTERVIEW =
  flag(import.meta.env.VITE_DEV_BYPASS_BEHAVIORAL_INTERVIEW);

export const DEV_CASE_SIM_TOOLS =
  flag(import.meta.env.VITE_DEV_CASE_SIM_TOOLS);
